import { memo } from 'react';
import { Handle, Position, type NodeProps } from '@xyflow/react';
import type { FlowNode, WaitData } from '../../types';
import { Icon } from '../Icon';
import { NodeIssueBadge } from './NodeIssueBadge';

function WaitNodeImpl({ data, selected, id }: NodeProps<FlowNode>) {
  const d = data as WaitData;
  return (
    <div className={`vnode wait ${selected ? 'selected' : ''}`} data-node-id={id}>
      <NodeIssueBadge issues={(d as any).__issues} />
      <Handle type="target" position={Position.Top} id="in" />
      <div className="vnode-head">
        <span className="vnode-lbl">
          <Icon name="clock" size={11} variant="silver" />
          Wait · pause for
        </span>
      </div>
      <div className="vcard vcard-wait">
        <div className="vcard-timer">
          <span className="vcard-timer-num">{d.amount}</span>
          <span className="vcard-timer-unit">{d.unit}</span>
        </div>
        <div className="vcard-wait-meta">
          <b>{d.label}</b>
          {d.description && <span className="vcard-meta">{d.description}</span>}
        </div>
      </div>
      <Handle type="source" position={Position.Bottom} id="out" />
    </div>
  );
}

export const WaitNode = memo(WaitNodeImpl);
